module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card admin"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Статистика звонков\n            "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    class: {
      active: _vm.showFilter
    },
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showFilter = !_vm.showFilter
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Фильтр\n                ")])]), _vm._v(" "), (_vm.showFilter) ? _c('div', {
    staticClass: "row mt-1"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('form', {
    attrs: {
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Номер телефона")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.query),
      expression: "params.query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.params.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "query", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Город")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.cities,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Город не выбран",
      "track-by": "id",
      "label": "name"
    },
    on: {
      "input": _vm.changeCity
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Номер на который позвонили")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.virtualNumbers,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Номер не выбран",
      "track-by": "id",
      "label": "name",
      "loading": _vm.loadingVirtualNumbers
    },
    on: {
      "input": _vm.changeVirtualNumber,
      "open": _vm.loadVirtualNumbers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Внутренний номер, который ответил")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.internalNumbers,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Номер не выбран",
      "track-by": "id",
      "label": "number",
      "loading": _vm.loadingInternalNumbers
    },
    on: {
      "input": _vm.changeInternalNumber,
      "open": _vm.loadInternalNumbers
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('form', {
    attrs: {
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Интервал с")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.dateTimeFrom),
      expression: "params.dateTimeFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.params.dateTimeFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "dateTimeFrom", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Интервал по")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.dateTimeTo),
      expression: "params.dateTimeTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.params.dateTimeTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "dateTimeTo", $event.target.value)
      }
    }
  })])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-block admin__list"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем звонки..."
    }
  }) : _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "row mb-1 admin__list__item admin__list__item_hover-bg-gray"
    }, [_c('div', {
      staticClass: "col-6 col-md-3 col-lg-2"
    }, [_vm._v(_vm._s(item.date) + " " + _vm._s(item.time))]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-3 col-lg-1"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-4 col-lg-1"
    }, [(item.virtualNumber) ? _c('span', [_vm._v(_vm._s(item.virtualNumber.number))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2 col-lg-1"
    }, [(item.virtualNumber && item.virtualNumber.city) ? _c('span', [_vm._v("\n                        " + _vm._s(item.virtualNumber.city.name) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-3 col-lg-2"
    }, [(item.virtualNumber) ? _c('span', [_vm._v("\n                        " + _vm._s(item.virtualNumber.site) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-7 col-lg-2"
    }, [(item.internalNumber) ? [_vm._v("\n                        Внутренний номер: " + _vm._s(item.internalNumber.number)), _c('br'), _vm._v(" "), _vm._l((item.internalNumber.users), function(user, index) {
      return _c('span', {
        staticClass: "badge badge-info"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'ViewProfile',
            params: {
              id: user.id
            }
          }
        }
      }, [_vm._v(_vm._s(user.fullname))])], 1)
    })] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "col-12 col-md-2 text-center text-md-left"
    }, [(item.records) ? _vm._l((item.records), function(record) {
      return _c('audio', {
        ref: "player",
        refInFor: true,
        attrs: {
          "controls": ""
        }
      }, [_c('source', {
        attrs: {
          "src": record.url
        }
      }), _vm._v("\n                            Ваш браузер не поддрживает воспроизведение аудио записей\n                        ")])
    }) : (_vm.loadingRecords === item.pbxCallId) ? _c('loading', {
      attrs: {
        "size": 2,
        "message": "Загружаем записи..."
      }
    }) : _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "secondary"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.loadRecords(item.pbxCallId, index)
        }
      }
    }, [_vm._v("Загрузить")])], 2)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "size": "md",
      "total-rows": _vm.itemsPage.paginator.total_count,
      "per-page": _vm.itemsPage.paginator.limit
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.$set(_vm.params, "page", $$v)
      },
      expression: "params.page"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb-1 text-muted small"
  }, [_c('div', {
    staticClass: "col-6 col-md-3 col-lg-2"
  }, [_vm._v("Дата и время")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3 col-lg-1"
  }, [_vm._v("Номер звонившего")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4 col-lg-1"
  }, [_vm._v("Номер на который звонили")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2 col-lg-1"
  }, [_vm._v("Город")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3 col-lg-2"
  }, [_vm._v("Сайт")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-7 col-lg-2"
  }, [_vm._v("Кто ответил")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2 col-lg-2"
  }, [_vm._v("Запись разговора")])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-777e41eb"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Admin/PBX/IncomingCalls.vue
// module id = 1052
// module chunks = 1